<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">{{ translations.service }}</h2>
            <div>
              <p>
                {{ translations.service2.text1 }}
              </p>
              <p>
                {{ translations.service2.text2 }}
              </p>
              <p>
                {{ translations.service2.text3 }}
              </p>
              <p>
                {{ translations.service2.text4 }}
              </p>
              <p>
                {{ translations.service2.text5 }}
              </p>
              <p>
                {{ translations.service2.text6 }}
                <strong>{{ translations.service2.text7 }} </strong
                ><a href="mailto:webshop@eurosan.ba"><strong>webshop@eurosan.ba</strong></a
                ><strong> &nbsp;</strong>
              </p>
              <p>
                {{ translations.service2.text8 }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { translations } from '@/mixins';

export default {
  name: 'Service',
  mixins: [translations],
};
</script>
